import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/authStore';

// Early-access gate — shown after login when the account isn't approved yet
// (user_profiles.access_status). check_app_access() re-checks server-side and
// auto-approves once an admin has approved this email in the console.
export function AccessPendingScreen({ onGranted }: { onGranted: () => void }) {
  const signOut = useAuthStore((s) => s.signOut);
  const [checking, setChecking] = useState(false);
  const [stillPending, setStillPending] = useState(false);

  const recheck = async () => {
    setChecking(true);
    setStillPending(false);
    const { data, error } = await supabase.rpc('check_app_access');
    setChecking(false);
    if (!error && data === true) onGranted();
    else setStillPending(true);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card border border-border rounded-lg p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l2.5 2.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-foreground mb-2">You&apos;re on the list</h2>
        <p className="text-muted-foreground mb-6">
          Metanoia OS is in private early access. Your account is created — we&apos;ll
          unlock it as soon as your request is approved. You&apos;ll be able to sign
          in right here.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => void recheck()}
            disabled={checking}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity disabled:opacity-60"
          >
            {checking ? 'Checking…' : 'Check again'}
          </button>
          <button
            onClick={() => void signOut()}
            className="px-4 py-2 border border-border text-foreground rounded-md hover:bg-muted transition-colors"
          >
            Sign out
          </button>
        </div>
        {stillPending && (
          <p className="text-muted-foreground text-sm mt-4">Not approved yet — hang tight.</p>
        )}
      </div>
    </div>
  );
}
